/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function PettyCashBookInfo({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { details = [] } = values;

  const handleChangeField = (path, val) => {
    setFieldValue(path, val);
  };

  const handleChangeTable = (index, field, val) => {
    const newDetails = [...details];
    newDetails[index][field] = val;
    setFieldValue("details", newDetails);
  };

  useEffect(() => {
    const opening = parseFloat(values.openingBalance) || 0;
    
    let runningBalance = opening;
    let totalDebit = 0;
    let totalCredit = 0;

    const updatedDetails = details.map((row) => {
      const dbAmt = parseFloat(row.debitAmount) || 0;
      const crAmt = parseFloat(row.creditAmount) || 0;

      totalDebit += dbAmt;
      totalCredit += crAmt;

      runningBalance = runningBalance + dbAmt - crAmt;

      return {
        ...row,
        balanceAmount: runningBalance
      };
    });

    const hasChanged = JSON.stringify(updatedDetails) !== JSON.stringify(details);
    const totalsChanged = 
      values.totalDebitAmount !== totalDebit || 
      values.totalCreditAmount !== totalCredit || 
      values.closingBalance !== runningBalance;

    if (hasChanged) {
      setFieldValue("details", updatedDetails);
    }
    
    if (totalsChanged) {
      setFieldValue("totalDebitAmount", totalDebit);
      setFieldValue("totalCreditAmount", totalCredit);
      setFieldValue("closingBalance", runningBalance);
    }
  }, [values.openingBalance, JSON.stringify(details.map(d => ({ db: d.debitAmount, cr: d.creditAmount })))]);

  const addRow = () => {
    const template = {
      recordingDate: "",
      docDate: "",
      receiptDocNumber: "",
      paymentDocNumber: "",
      description: "",
      offsetAccount: "",
      debitAmount: 0,
      creditAmount: 0,
      balanceAmount: 0,
      note: ""
    };
    setFieldValue("details", [...details, template]);
  };

  const removeRow = (index) => {
    if (details.length <= 1) return;
    const newDetails = details.filter((_, i) => i !== index);
    setFieldValue("details", newDetails);
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px", lineHeight: "1.5" },
    headerTop: { display: "flex", justifyContent: "space-between", marginBottom: "15px" },
    titleBox: { textAlign: "center", margin: "10px 0" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: "13px", marginTop: "15px", marginBottom: "15px" },
    th: { border: "1px solid #000", padding: "8px 4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#fff" },
    td: { border: "1px solid #000", padding: 0, height: "35px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 4px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 4px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "16px" },
    rowLabel: { display: "flex", alignItems: "baseline", gap: "5px", marginBottom: "8px" }
  };

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={s.headerTop}>
        <div style={{ width: "45%" }}>
          <div style={s.rowLabel}>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.unit} onChange={(e) => handleChangeField("unit", e.target.value)} /></div>
          <div style={s.rowLabel}>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.address} onChange={(e) => handleChangeField("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "55%" }}>
          <div style={{ fontWeight: "bold", fontSize: "16px" }}>Mẫu số S07a-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={s.titleBox}>
        <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "18px" }}>SỔ KẾ TOÁN CHI TIẾT QUỸ TIỀN MẶT</h2>
        <div style={{ marginTop: 10 }}>
          Tài khoản: <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center", fontWeight: "bold" }} value={values.accountNumber} onChange={(e) => handleChangeField("accountNumber", e.target.value)} />
        </div>
        <div style={{ marginTop: 5 }}>
          Loại quỹ: <input disabled={containView} style={{ ...s.inputDotted, width: "200px", textAlign: "center" }} value={values.fundType} onChange={(e) => handleChangeField("fundType", e.target.value)} />
        </div>
        <div style={{ marginTop: 5, fontWeight: "bold" }}>
          Năm: <input disabled={containView} style={{ ...s.inputDotted, width: "80px", textAlign: "center" }} value={values.year} onChange={(e) => handleChangeField("year", e.target.value)} />
        </div>
      </div>
      <div style={{ textAlign: "right", fontStyle: "italic" }}>Đơn vị tính: <input disabled={containView} style={{ ...s.inputDotted, width: "80px" }} value={values.itemUnit} onChange={(e) => handleChangeField("itemUnit", e.target.value)} /></div>

      {/* TABLE 10 COLUMNS */}
      <div style={{ overflowX: "auto" }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "70px" }} rowSpan={2}>Ngày, <br/>tháng ghi sổ</th>
              <th style={{ ...s.th, width: "70px" }} rowSpan={2}>Ngày, tháng <br/>chứng từ</th>
              <th style={s.th} colSpan={2}>Số hiệu chứng từ</th>
              <th style={{ ...s.th, width: "200px" }} rowSpan={2}>Diễn giải</th>
              <th style={{ ...s.th, width: "60px" }} rowSpan={2}>TK đối <br/>ứng</th>
              <th style={s.th} colSpan={2}>Số phát sinh</th>
              <th style={{ ...s.th, width: "100px" }} rowSpan={2}>Số tồn</th>
              <th style={{ ...s.th, width: "100px" }} rowSpan={2}>Ghi chú</th>
              {!containView && <th style={{ ...s.th, width: "40px" }} rowSpan={3}>#</th>}
            </tr>
            <tr>
              <th style={{ ...s.th, width: "70px" }}>Thu</th>
              <th style={{ ...s.th, width: "70px" }}>Chi</th>
              <th style={{ ...s.th, width: "90px" }}>Nợ</th>
              <th style={{ ...s.th, width: "90px" }}>Có</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>C</th>
              <th style={s.th}>D</th>
              <th style={s.th}>E</th>
              <th style={s.th}>F</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3</th>
              <th style={s.th}>G</th>
            </tr>
          </thead>
          <tbody>
            {/* SỐ TỒN ĐẦU KỲ */}
            <tr style={{ fontWeight: "bold" }}>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={{ ...s.td, padding: "0 8px" }}>- Số tồn đầu kỳ</td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}>
                <input
                  disabled={containView}
                  type="number"
                  style={{ ...s.inputTableRight, fontWeight: "bold" }}
                  value={values.openingBalance}
                  onChange={(e) => handleChangeField("openingBalance", e.target.value)}
                />
              </td>
              <td style={s.td}></td>
              {!containView && <td style={s.td}></td>}
            </tr>
            
            <tr style={{ fontStyle: "italic" }}>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={{ ...s.td, padding: "0 8px" }}>- Số phát sinh trong kỳ</td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              {!containView && <td style={s.td}></td>}
            </tr>

            {/* DÒNG PHÁT SINH */}
            {(details || []).map((item, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.recordingDate} onChange={(e) => handleChangeTable(idx, "recordingDate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.docDate} onChange={(e) => handleChangeTable(idx, "docDate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.receiptDocNumber} onChange={(e) => handleChangeTable(idx, "receiptDocNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.paymentDocNumber} onChange={(e) => handleChangeTable(idx, "paymentDocNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.description} onChange={(e) => handleChangeTable(idx, "description", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.offsetAccount} onChange={(e) => handleChangeTable(idx, "offsetAccount", e.target.value)} /></td>
                
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.debitAmount} onChange={(e) => handleChangeTable(idx, "debitAmount", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.creditAmount} onChange={(e) => handleChangeTable(idx, "creditAmount", e.target.value)} /></td>
                
                <td style={{ ...s.td, backgroundColor: "#fdfdfd" }}><input disabled style={{ ...s.inputTableRight, fontWeight: "bold" }} value={fmt(item.balanceAmount)} /></td>
                
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.note} onChange={(e) => handleChangeTable(idx, "note", e.target.value)} /></td>
                {!containView && <td style={{ ...s.td, textAlign: "center" }}><button type="button" style={s.removeBtn} onClick={() => removeRow(idx)}>–</button></td>}
              </tr>
            ))}
            
            {/* DÒNG CỘNG SỐ PHÁT SINH TRONG KỲ */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#fafafa" }}>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={{ ...s.td, padding: "0 8px" }}>- Cộng số phát sinh trong kỳ</td>
              <td style={{ ...s.td, textAlign: "center" }}>X</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(values.totalDebitAmount)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(values.totalCreditAmount)}</td>
              <td style={{ ...s.td, textAlign: "center" }}>X</td>
              <td style={{ ...s.td, textAlign: "center" }}>X</td>
              {!containView && <td style={s.td}></td>}
            </tr>
            
            {/* DÒNG SỐ DƯ CUỐI KỲ */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#fafafa" }}>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={{ ...s.td, padding: "0 8px" }}>- Số tồn cuối kỳ</td>
              <td style={{ ...s.td, textAlign: "center" }}>X</td>
              <td style={{ ...s.td, textAlign: "center" }}>X</td>
              <td style={{ ...s.td, textAlign: "center" }}>X</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px", color: "blue" }}>{fmt(values.closingBalance)}</td>
              <td style={{ ...s.td, textAlign: "center" }}>X</td>
              {!containView && <td style={s.td}></td>}
            </tr>
          </tbody>
        </table>
        {!containView && (
          <SoftBox textAlign="center" mb={2}>
            <SoftButton variant="outlined" color="dark" size="small" onClick={addRow}>+ Thêm nghiệp vụ</SoftButton>
          </SoftBox>
        )}
      </div>

      {/* FOOTER: INFO */}
      <div style={{ marginTop: "15px" }}>
        <div style={s.rowLabel}>- Sổ này có <input disabled={containView} style={s.inputDottedSmall} value={values.totalPages} onChange={(e) => handleChangeField("totalPages", e.target.value)} /> trang, đánh số từ trang 01 đến trang...</div>
        <div style={s.rowLabel}>- Ngày mở sổ: <input disabled={containView} style={{ ...s.inputDotted, width: "150px" }} value={values.openingDate} onChange={(e) => handleChangeField("openingDate", e.target.value)} /></div>
      </div>

      {/* FOOTER: SIGNATURES */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Người ghi sổ</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => handleChangeField("ledgerClerk", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Kế toán trưởng</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => handleChangeField("chiefAccountant", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "14px", marginBottom: "5px" }}>
            Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => handleChangeField("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => handleChangeField("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => handleChangeField("signingYear", e.target.value)} />
          </div>
          <div style={{ fontWeight: "bold" }}>Người đại diện theo pháp luật</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên, đóng dấu)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "200px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => handleChangeField("legalRepresentative", e.target.value)} />
          </SoftBox>
        </div>
      </div> */}
    </SoftBox>
  );
}
